// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 007_fatmap_api_route_content.djinni
/** Used to specify the style of a selected route */
export var RouteSelectionStyle;
(function (RouteSelectionStyle) {
    /**
     * Uses a gradient for the style, should only be applied to one route at a time.
     * @note The only surface type supported with this style is paved.
     */
    RouteSelectionStyle[RouteSelectionStyle["GRADIENT"] = 0] = "GRADIENT";
    /** The default style for canonical routes */
    RouteSelectionStyle[RouteSelectionStyle["CANONICAL"] = 1] = "CANONICAL";
})(RouteSelectionStyle || (RouteSelectionStyle = {}));
